// @ts-check
import { useGetters } from 'vuex-composition-helpers/dist';

export function useUser() {
  /** @type {import('@/store/modules/users/user').TUserGetters} */
  const { user } = useGetters({
    user: 'user/user',
  });

  return user;
}
